import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Extintor Digestivo',
    items: ['Qué está pasando realmente en tu intestino', 'El Termómetro Matutino: tu diagnóstico diario', 'El Protocolo de las Primeras 48 Horas paso a paso', 'La Infusión VTG que trabaja sobre la causa real', 'Las señales de alerta que necesitan atención médica'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — El Menú Gravedad Cero',
    items: ['La Regla 50/30/20 adaptada al intestino de la mujer de +55', '15 desayunos + 15 almuerzos + 15 cenas anti-inflamación', 'El Protocolo del Asado Argentino: cómo disfrutarlo sin globo', 'Lista de compras lista para imprimir y guardar en el celular'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — El Manual del Supermercado Argentino',
    items: ['El Semáforo Digestivo Verde/Amarillo/Rojo para la mujer de +55', 'Los 10 alimentos "saludables" que más inflan y sus reemplazos exactos', 'Las 8 palabras en etiquetas que hacen que el producto vuelva a la góndola', 'Marcas argentinas reales disponibles en cualquier súper'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — El Escudo Social',
    items: ['El Protocolo Pre-Salida para cualquier evento social', '6 escenarios reales: asado, restaurante, pizzería, bodegón, evento y viaje', 'El Guión del Mozo: cómo pedir en cualquier restaurante argentino', 'Protocolo de Rescate 24 horas post-exceso'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Plan de Liviandad Sostenida',
    items: ['Los 5 Hábitos del Despertar que definen tu panza todo el día', 'El Masaje I-L-U Nocturno que prepara el intestino para repararse', 'La Recalibración Mensual para ajustar el sistema cada 30 días', 'El Test de Vitalidad para medir tu progreso real'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan paso a paso, listo para arrancar hoy', 'Recetas fáciles con ingredientes de tu feria', 'Resultados visibles en 48hs', 'Checklist imprimible por etapa', 'Tracker de síntomas + criterios de medición', 'Errores frecuentes y cómo evitarlos', '100% adaptado a la mujer argentina'];
  return <section className="py-24 bg-brand-dark" data-id="element-223">
      <div className="container mx-auto px-4" data-id="element-224">
        <div className="max-w-5xl mx-auto" data-id="element-225">
          <div className="text-center mb-16" data-id="element-226">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-227">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-228">
                SISTEMA LIVIANDAD FINAL™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-229">
                Protocolos de Alivio Inmediato: Implementación en 5 minutos
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-230">
            📚 LOS 5 TOMOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-231">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-232">
                <div className="text-5xl shrink-0" data-id="element-233">{tomo.emoji}</div>
                <div data-id="element-234">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-235">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-236">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-237">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-238" />
                        <span data-id="element-239">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-240">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-241">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-242">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-243">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-244" />
                  <span className="text-gray-200" data-id="element-245">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}